export const DEFAULT_LOCALE = 'en_int';

export const LOCALE_TRANSLATIONS_URLS = {
  development: locale => `/assets/locales/${locale}/translations.json`,
  test: locale => `/assets/locales/${locale}/translations.json`,
  preProduction: locale => `/store/assets/locales/${locale}/translations.json`,
  production: locale => `/store/assets/locales/${locale}/translations.json`
};

export const SITEACCESS = {
  en_gb: 'en_gb',
  fr_fr: 'default',
  de_de: 'de_de',
  es_es: 'es_es',
  it_it: 'it_it',
  zh_cn: 'cn_cn',
  ko_kr: 'kr_kr',
  fr_be: 'fr_be',
  nl_be: 'en_be',
  nl_nl: 'nl_nl',
  ru_ru: 'ru_ru',
  pt_br: 'po_br',
  en_us: 'en_us',
  zh_hk: 'cn_hk',
  ja_jp: 'jp_jp',
  zh_tw: 'cn_tw',
  en_int: 'en_int',
  es_sam: 'es_int',
  en_hk: 'en_hk'
};



// WEBPACK FOOTER //
// ./src/settings/locale.js